
import React from 'react';
import EditNameModal from '../EditNameModal';
import AudioTranscriptModal from '../AudioTranscriptModal';

interface Conversation {
  speaker: 'Business' | 'Lead';
  text: string;
}

interface LeadModalsProps {
  editingName: string | null;
  transcriptModalOpen: boolean;
  activeLeadId: string | null;
  initialName: string;
  transcript: readonly Conversation[];
  onCloseNameModal: () => void;
  onCloseTranscriptModal: () => void;
  onSaveName: (id: string, name: string) => void;
}

const LeadModals: React.FC<LeadModalsProps> = ({
  editingName,
  transcriptModalOpen,
  activeLeadId,
  initialName,
  transcript,
  onCloseNameModal,
  onCloseTranscriptModal,
  onSaveName
}) => {
  return (
    <>
      {editingName && (
        <EditNameModal
          isOpen={true}
          onClose={onCloseNameModal}
          initialName={initialName}
          onSave={(newName) => onSaveName(editingName, newName)}
        />
      )}
      
      {transcriptModalOpen && activeLeadId && (
        <AudioTranscriptModal
          isOpen={transcriptModalOpen}
          onClose={onCloseTranscriptModal}
          transcript={transcript}
        />
      )}
    </>
  );
};

export default LeadModals;
